interface Promisify<T> {
  instance: Promise<T>
  reject: (reason?: unknown) => void
  resolve: (value: T | PromiseLike<T>) => void
}

const createPromisify = <T = void>() => {
  const promisify = {} as Promisify<T>

  promisify.instance = new Promise<T>((resolve, reject) => {
    promisify.reject = reject
    promisify.resolve = resolve
  })

  return promisify
}

export default createPromisify
